export enum RolesEnum {
  PATIENT = 1,
  CAREGIVER = 2,
  MANAGER = 3,
}
